import { render, staticRenderFns } from "./EnquiryStatusChip.vue?vue&type=template&id=23291194&scoped=true&"
import script from "./EnquiryStatusChip.vue?vue&type=script&lang=js&"
export * from "./EnquiryStatusChip.vue?vue&type=script&lang=js&"
import style0 from "./EnquiryStatusChip.vue?vue&type=style&index=0&id=23291194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23291194",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
